module.exports = __webpack_public_path__ + "static/media/possibility.3c84ae26.png";